import type { FC } from 'react'
import { logout } from '../../features/auth/authSlice'
import { selectIsLoggedIn } from '../../features/auth/selectors/authSelectors'
import BmwGroupLogo from '../../assets/images/bmw-group-logo.svg'
import LogoutIcon from '../../assets/images/logout_rg.svg'
import { ContentContainer } from '../ContentContainer/ContentContainer'
import { useAppDispatch, useAppSelector } from '../../hooks'
import './styles.css'

const NavBar: FC = () => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <>
      <ContentContainer>
        <div className="navbar-component">
          <div className="navbar-left">
            <img className="brand-image" src={BmwGroupLogo} alt="BMW Group Logo" />
          </div>
          <div className="navbar-right">
            {isLoggedIn && (
              <button className="icon-btn" onClick={handleLogout} type="button">
                <img src={LogoutIcon} alt="Logout" />
              </button>
            )}
          </div>
        </div>
      </ContentContainer>
      <div className="header-line"></div>
    </>
  )
}

export default NavBar
